import type {ZoomVideoSDKVirtualBackgroundDataType} from "react-native-zoom-video-sdk";

/**
 * Virtual background item interface.
 */
export type ZoomVideoSdkVirtualBackgroundItemType = {
    /**
     * The file path of the image.
     */
    filePath: string;

    /**
     * Get the current item image name.
     */
    imageName: string;

    /**
     * Get the current item background type.
     */
    type: ZoomVideoSDKVirtualBackgroundDataType;

    /**
     * Determine whether the virtual background can be deleted.
     */
    canBeDeleted: boolean;
};

export class ZoomVideoSdkVirtualBackgroundItem implements ZoomVideoSdkVirtualBackgroundItemType {
    filePath;
    imageName;
    type;
    canBeDeleted;

    constructor(item: ZoomVideoSdkVirtualBackgroundItemType) {
        this.filePath = item.filePath;
        this.imageName = item.imageName;
        this.type = item.type;
        this.canBeDeleted = item.canBeDeleted;
    }
}
